// src/components/ui/StatusBadge.jsx
import React from "react";
import { useTheme } from "../../context/ThemeContext.jsx";
import PillBadge from "./PillBadge.jsx";
import { STATUS_VALUES, STATUS_COLORS, normalizeStatus, prettyStatus, OFFERTE_STATUS_VALUES, OFFERTE_STATUS_COLORS, normalizeOfferteStatus, prettyOfferteStatus, MANGEL_STATUS_VALUES, normalizeMaengelStatus } from "../../constants/status.js";
function getFallbackCls() {
  return "bg-white/10 text-blue-100 border-white/15";
}

/**
 * StatusBadge
 * @param {string} status
 * @param {'service'|'offerte'|'maengel'|'generic'} entity
 * @param {string} className
 * @param {boolean} pulse
 */
export default function StatusBadge({
  status,
  entity = "generic",
  className = "",
  pulse = false
}) {
    let label = "Unbekannt";
  let known = false;
  let colorCls = getFallbackCls();
  if (entity === "offerte") {
    const norm = normalizeOfferteStatus(status);
    label = prettyOfferteStatus(norm) || "Unbekannt";
    known = OFFERTE_STATUS_VALUES.includes(norm);
    colorCls = OFFERTE_STATUS_COLORS[norm] || colorCls;
  } else if (entity === "maengel") {
    const norm = normalizeMaengelStatus(status);
    label = norm || "Unbekannt";
    known = MANGEL_STATUS_VALUES.includes(norm);
    colorCls = STATUS_COLORS[norm] || colorCls;
  } else {
    // Service / generic (bestehendes Verhalten)
    const norm = normalizeStatus(status);
    label = prettyStatus(norm) || "Unbekannt";
    known = STATUS_VALUES.includes(label);
    colorCls = STATUS_COLORS[norm] || colorCls;
  }
  return <PillBadge label={label} title={label} ariaLabel={`Status: ${label}`} toneClassName={known ? colorCls : getFallbackCls()} size="status" pulse={pulse} className={className} />;
}